module.exports = __webpack_public_path__ + "img/banner-shoppings.a8606865.jpg";